import { useState } from "react"
import { FilterVehicle } from "../../../../../../api/vehicles/filter"
import { AddedFleetEntry } from "../../../../../../api/fleet"
import { fieldHasAllPrerequisiteValues } from "../../utils"
import { DropdownFieldComponent } from "../fields/DropdownFieldComponent"
import { DropdownConfirmComponentWithDataLoad, prerequisiteFields } from "./DropdownConfirmComponentWithDataLoad"

export type GeneratorOpts = {
  entry: AddedFleetEntry
  dataTestId?: string
  onConfirmed: (vehicle: FilterVehicle) => void
}

export const generateManuallyResolveFleetEntryConfirm = (opts: GeneratorOpts) => {
  const { entry, dataTestId, onConfirmed } = opts
  return function () {
    const value = entry.vehicleId
      ? [entry.make, entry.model, entry.trim, entry.nominalStartYear].filter((it) => !!it).join(` `)
      : null
    const [isOpen, setIsOpen] = useState(false)
    const hasAllFields = fieldHasAllPrerequisiteValues(entry, prerequisiteFields)

    if (!hasAllFields || (value !== null && !isOpen))
      return (
        <DropdownFieldComponent
          dataTestId={dataTestId}
          disabled={hasAllFields}
          dropdownValues={[]}
          value={value}
          setIsOpen={setIsOpen}
          onChange={() => {}}
        />
      )

    return (
      <DropdownConfirmComponentWithDataLoad
        dataTestId={dataTestId}
        entry={entry}
        value={value}
        setIsOpen={setIsOpen}
        onConfirmed={onConfirmed}
      />
    )
  }
}
